import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockTilesFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 * Lazy per the block-loading rule: not on the critical rendering path.
 */
export const tilesBlockConfig = {
  name: 'inner-block-tiles',
  component: defineAsyncComponent(() => import('./CmsTiles.vue')),
  innerComponent: defineAsyncComponent(() => import('./TilesGrid.vue')),
  fields: blockTilesFields,
} satisfies ModularBlockConfig;
